import { IHisInfoGroupBehavior } from ".";
import { User } from "../../../user";
import { HisInformationItem } from "../../";
import { IHisInformationApplicable } from "../../../document/items";

/**
 * カナ氏名の選択時に医療機関_医師名・作成者・医師選択をグループ入力するために
 * HIS情報を生成する。
 */
export class UserKanaNameBehavior implements IHisInfoGroupBehavior {
  private readonly Key = "USER_KANA_NAME";

  private readonly CreateUserKey = "CREATE_USER";
  private readonly DoctorKey = "DOCTOR";
  private readonly DoctorSelectKey = "DOCTOR_SELECT";

  private groupKeys = [ this.CreateUserKey, this.DoctorKey, this.DoctorSelectKey ];

  constructor(private users: User[]) {}

  createHisInfoItems(): HisInformationItem[] {
    if (this.users === null) { return [ new HisInformationItem(this.Key, "") ]; }

    const names = this.users.map(x => x.name);
    const kanaItems = this.users.map(x => new HisInformationItem(this.Key, x.kanaName));
    const createUserItems = names.map(x => new HisInformationItem(this.CreateUserKey, x));
    const doctorItems = names.map(x => new HisInformationItem(this.DoctorKey, x));
    const doctorSelectItems = names.map(x => new HisInformationItem(this.DoctorSelectKey, x));
    const items = kanaItems
      .concat(createUserItems)
      .concat(doctorItems)
      .concat(doctorSelectItems);
    return items;
  }

  areSameGroup(item: IHisInformationApplicable): boolean {
    return this.groupKeys.indexOf(item.hisItemParameter.key) >= 0;
  }
}
